module.exports = __webpack_public_path__ + "static/media/img17.1c11462c.jpg";